import PermissionItem from '@activities/MainActivity/PermissionBottomSheet/PermissionItem';
import Button from '@components/Button';
import Column from '@components/Column';
import Text from '@components/Text';
import styled from '@emotion/styled';
import useProject from '@hooks/useProject';
import { Permission } from '@models/permission';
import { useFlow } from '@router/stackflow';
import { BottomSheet } from '@stackflow/plugin-basic-ui';
import { ActivityComponentType } from '@stackflow/react';
import NativeUtil from '@utils/NativeUtil';

const PermissionBottomSheet: ActivityComponentType = () => {
  const { pop } = useFlow();
  window.localStorage.setItem('permissionAsked', 'true');
  const handleRequestPermission = () => {
    NativeUtil.postMessage('requestPermission', Permission.NOTIFICATION);
    pop();
  };
  const project = useProject();
  return (
        <BottomSheet>
            <Container>
                <Column fullWidth align='center'>
                    <Header>
                        <Text size='2xl' fontWeight='bold'>
                            앱을 사용하기 전에
                        </Text>
                    </Header>
                    <Description>
                        <Text align='center'>
                            코코넛 서비스는 더 나은 서비스 제공을 위해 다음과 같은 휴대폰 기능에 접근하고 있습니다.
                        </Text>
                    </Description>
                    <Contents fullWidth spacing={18}>
                        <PermissionItem name='기기정보'>
                            서비스 분석 및 통계, 푸시 발송, 오류정보 확인
                        </PermissionItem>
                        <PermissionItem name='저장공간'>
                            이미지 데이터 및 요청사항 저장
                        </PermissionItem>
                        <PermissionItem name='알림'>
                            푸시알림
                        </PermissionItem>
                        <PermissionItem name='GPS'>
                            단말기의 위치정보 기능 사용
                        </PermissionItem>
                        <PermissionItem name='전화'>
                            매장찾기
                        </PermissionItem>
                        {project?.features.inquiryEnabled && (
                            <PermissionItem name='갤러리/카메라'>
                                고객센터
                            </PermissionItem>
                        )}
                        {project?.features.giftEnabled && (
                            <PermissionItem name='연락처'>
                                선물하기
                            </PermissionItem>
                        )}
                    </Contents>
                    <Footer>
                        <Button fullWidth
                                onClick={handleRequestPermission} >
                            확인
                        </Button>
                    </Footer>
                </Column>
            </Container>
        </BottomSheet>
  );
};

const Header = styled.div`
    padding: 32px 0;
`;

const Description = styled.div`
    padding: 0 20px 20px;
    max-height: 80vh;
    overflow-y: auto;
`;

const Contents = styled(Column)`
    overflow: scroll;
    max-height: calc(100vh - 152px);
    padding-bottom: calc(96px + env(safe-area-inset-bottom));
`;

const Container = styled.div`
    padding: 0 20px;
    position: relative;
    height: 100%;
`;

const Footer = styled.footer`
    width: 100%;
    //padding: 10vh 0 calc(20px + env(safe-area-inset-bottom));
    position: absolute;
    padding: 0 20px calc(20px + env(safe-area-inset-bottom));
    bottom: 0;
`;

export default PermissionBottomSheet;
